<template>
  <v-sheet class="my-3">
    <v-tabs grow>
      <v-tab v-for="s in snapshots" :key="s.id">
        {{ s.category | categoryAsName }}
      </v-tab>
      <v-tab-item v-for="s in snapshots" :key="s.id">
        <v-img
          :src="`http://auk.agr-iot.com/pic/${s.name}.jpg`"
          max-width="1260"
        ></v-img>
      </v-tab-item>
    </v-tabs>
  </v-sheet>
</template>
<script>
import { getShortcut } from '@/api/shortcut.js'

export default {
  props: ['shortcutId'],
  data: () => ({
    detail: undefined,
    snapshots: [],
  }),
  mounted() {
    console.log('expand mounted')
    getShortcut(this.shortcutId).then((resp) => {
      console.log('快照详细::', resp)
      this.detail = resp.shortcut
      this.snapshots = resp.snapshots
    })
  },
  filters: {
    categoryAsName(val) {
      return ['', '实验区抓图', '操作区抓图'][val]
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/history/HistoryDetailTableExpand.vue